import React from 'react';
// Ensure your CSS file is imported
import '../App.css';

const NewsCarousel = ({ images }) => {
    if (!images || images.length === 0) return null;

    return (
        <div className="stacked-image-container">
            {images.map((imgUrl, index) => (
                <div
                    key={index}
                    className="stacked-card"
                    style={{ '--index': index }}
                >
                    {/* Added .default fallback for older/newer require compatibility */}
                    <img src={imgUrl.default || imgUrl} alt={`News slide ${index}`} />
                </div>
            ))}
        </div>
    );
};

export default NewsCarousel;